import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const CustomerState = Immutable.fromJS({
	customer: {
		customerId: '',
		customerName: '',
		contact: '',
		phone: '',
		fax: '',
		address: '',
		shippingAddress: '',
		receiptAddress: '',
		id: '',
		sId: ''
	},
	customerValidation: {
		customerId: {
			validationState: null,
			helpBlock: null
		},
		customerName: {
			validationState: null,
			helpBlock: null
		},
		contact: {
			validationState: null,
			helpBlock: null
		},
		phone: {
			validationState: null,
			helpBlock: null
		},
		fax: {
			validationState: null,
			helpBlock: null
		},
		address: {
			validationState: null,
			helpBlock: null
		},
		shippingAddress: {
			validationState: null,
			helpBlock: null
		},
		receiptAddress: {
			validationState: null,
			helpBlock: null
		},
		id: {
			validationState: null,
			helpBlock: null
		}
	},
	alertStyle: null,
	alertMessage: null,
	showModal: false,
	forInsert: true
});

const customerReducer = handleActions({
	CHANGE_CUSTOMER_VALUE: (state, { payload }) => {
		
		let customer = state.get('customer');
		return state.merge({
			customer: customer.set(payload.id, payload.value),
		})
	},
	ADD_CUSTOMER: (state, { payload }) => {
		return state.merge({
			customer: payload.data.bean,
			customerValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	EDIT_CUSTOMER: (state, { payload }) => {
		return state.merge({
			customer: payload.data.bean,
			customerValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	OPEN_CUSTOMER_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showModal: true
		})
	},	
	CLOSE_CUSTOMER_MODAL: (state, { payload }) => {
		return state.merge({
			customer: {
				customerId: '',
				customerName: '',
				contact: '',
				phone: '',
				fax: '',
				address: '',
				shippingAddress: '',
				receiptAddress: '',
				id: '',
				sId: ''
			},
			customerValidation: {
				customerId: {
					validationState: null,
					helpBlock: null
				},
				customerName: {
					validationState: null,
					helpBlock: null
				},
				contact: {
					validationState: null,
					helpBlock: null
				},
				phone: {
					validationState: null,
					helpBlock: null
				},
				fax: {
					validationState: null,
					helpBlock: null
				},
				address: {
					validationState: null,
					helpBlock: null
				},
				shippingAddress: {
					validationState: null,
					helpBlock: null
				},
				receiptAddress: {
					validationState: null,
					helpBlock: null
				},
				id: {
					validationState: null,
					helpBlock: null
				}
			},
			alertStyle: null,
			alertMessage: null,
			showModal: false,
			forInsert: true
		})
	},
	FIND_CUSTOMER: (state, { payload }) => {
		return state.merge({
			customer: payload.data
		})
	}
}, CustomerState);

export default customerReducer;


// WEBPACK FOOTER //
// ./src/reducers/customerReducer.js